import React from "react";
import moment from "moment";

const Item = ({ items, colorScheme, month }) => {
  const isToday = (date) => moment().isSame(moment(date), "day");
  const getTittle = (title) => {
    if (!(title[0].toUpperCase() >= "A" && title[0].toUpperCase() <= "Z"))
      return title.substring(1);
    return title;
  };

  return (
    <div className="w-full sm:px-2 md:px-10 mb-4 lg:pr-30">
      <div
        className="rounded-xl p-4 shadow-md"
        style={{
          background: colorScheme.background,
          boxShadow: colorScheme.shadow,
        }}
      >
        <div className="space-y-4 grid grid-cols-12">
          {items.map((item, index) => {
            const highlightToday = isToday(item.holiday_date);
            return (
              <>
                <div
                  key={item.id}
                  className={`justify-between items-center  pb-1 col-span-12 md:col-span-6 grid grid-cols-12 gap-3  ${
                    highlightToday
                      ? "border-2 rounded-full bg-green-500 text-white border-green-800"
                      : ""
                  }`}
                  // style={{ borderBottom: `1px solid ${colorScheme.text}` }}
                >
                  <div
                    className="col-span-4  text-center py-1"
                    // style={{ border: `1px solid ${colorScheme.text}` }}
                  >
                    <h3 className="text-4xl font-bold">
                      {moment(item.holiday_date).format("DD")}
                    </h3>
                    <h3
                      className="text-lg font-semibold"
                      // style={{ color: colorScheme.text }}
                    >
                      {moment(item.holiday_date).format("ddd")}
                    </h3>
                  </div>
                  <div className="col-span-8">
                    <p className="text-md font-semibold">
                      {getTittle(item.title)}
                    </p>
                  </div>
                </div>

                {index !== items.length - 1 && (
                  <div className="col-span-12 flex justify-center">
                    <div
                      className="border-b"
                      style={{ width: "70%", borderColor: colorScheme.text }}
                    ></div>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Item;
